var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page-mask page-mask-last"},[(!_vm.isIE11)?_c('svg',{staticClass:"page-mask--back",attrs:{"viewBox":"0 0 595.391 81.16","enable-background":"new 0 0 595.391 81.16"}},[_c('polygon',{attrs:{"fill":"#FFFFFF","points":"0,0 0,42.029 595.391,81.16 595.28,0 "}})]):_c('img',{staticClass:"page-mask--back",attrs:{"src":"/static/masks/mask-4.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9056080","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Masks/Mask4.vue
// module id = 277
// module chunks = 0